import { useSyncExternalStore } from 'react';

/** Below Tailwind's `md`: the phone layout. Tablets and up keep the board. */
const PHONE_QUERY = '(max-width: 767px)';

function phoneQuery(): MediaQueryList | null {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function')
    return null;
  return window.matchMedia(PHONE_QUERY);
}

function subscribe(onChange: () => void): () => void {
  const query = phoneQuery();
  query?.addEventListener('change', onChange);
  return () => {
    query?.removeEventListener('change', onChange);
  };
}

/**
 * Whether the screen is phone-sized, live as it rotates or resizes.
 *
 * By width, not user agent: what decides between the board and the tabs is
 * the room there is to show them. Without `matchMedia` (jsdom) it is desktop.
 */
export function useIsMobile(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => phoneQuery()?.matches ?? false,
    () => false,
  );
}
